import React, { useEffect } from 'react';
import { Container } from 'reactstrap';

// import logo
import HorizontalLayout from './HorizontalLayout';

import TrojanLogoIcon from 'components/Icons/TrojanLogo';
import useGetPestCompany from 'hooks/Clients/useGetPestCompany';
import EditPestCompanyModal from 'pages/ClientDashboardV2/EditPestCompanyModal';
import { useEditCompanyPestModalStore } from 'pages/ClientDashboardV2/hooks/EditCompanyPestModalStore';

import './Sidebar.scss';

const Sidebar = React.memo(() => {
  const { data: infoPestCompany } = useGetPestCompany();
  const isLogoHave = infoPestCompany?.logo;
  const { onManageEditMapOpen } = useEditCompanyPestModalStore();
  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName('vertical-overlay');
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener('click', function () {
        document.body.classList.remove('vertical-sidebar-enable');
      });
    }
  });

  const addEventListenerOnSmHoverMenu = () => {
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  return (
    <React.Fragment>
      <div className="app-menu navbar-menu">
        <div>
          <span className="trojan-logo-sm m-3">
            {isLogoHave ? (
              <img src={infoPestCompany.logo} alt="logo" height="22" style={{ cursor: 'pointer' }} />
            ) : (
              <TrojanLogoIcon height={22} />
            )}
          </span>
        </div>
        <div className="navbar-brand-box" onClick={() => onManageEditMapOpen()}>
          <div className="logo logo-dark">
            <span className="logo-sm">
              {isLogoHave ? (
                <img src={infoPestCompany.logo} alt="logo" height="14" style={{ cursor: 'pointer' }} />
              ) : (
                <TrojanLogoIcon height={14} />
              )}
            </span>
            <span className="logo-lg">
              {isLogoHave ? (
                <img src={infoPestCompany.logo} alt="logo" height="34" style={{ cursor: 'pointer' }} />
              ) : (
                <TrojanLogoIcon height={34} />
              )}
            </span>
          </div>
          <div className="logo logo-light">
            <span className="logo-sm">
              {isLogoHave ? (
                <img src={infoPestCompany.logo} alt="logo" height="22" style={{ cursor: 'pointer' }} />
              ) : (
                <TrojanLogoIcon height={22} />
              )}
            </span>
            <span className="logo-lg">
              {isLogoHave ? (
                <img src={infoPestCompany.logo} alt="logo" height="17" style={{ cursor: 'pointer' }} />
              ) : (
                <TrojanLogoIcon height={17} />
              )}
            </span>
          </div>

          <button
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line" />
          </button>
        </div>
        <div id="scrollbar" className="d-flex flex-column h-100">
          <Container fluid className="d-flex flex-column flex-grow-1">
            <div id="two-column-menu" />

            <ul className="navbar-nav" id="navbar-nav">
              <HorizontalLayout />
            </ul>

            <div className="mt-auto  text-center">
              <div className="navbar-brand-box ">
                {isLogoHave && (
                  <div>
                    <div className="logo logo-dark ">
                      <span className="logo-sm">
                        <TrojanLogoIcon height={14} />
                      </span>
                      <span className="logo-lg ">
                        <TrojanLogoIcon height={34} />
                      </span>
                    </div>
                    <div className="logo logo-light">
                      <span className="logo-sm">
                        <TrojanLogoIcon height={22} />
                      </span>
                      <span className="logo-lg">
                        <TrojanLogoIcon height={17} />
                      </span>
                    </div>
                  </div>
                )}

                <button
                  onClick={addEventListenerOnSmHoverMenu}
                  type="button"
                  className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                  id="vertical-hover"
                >
                  <i className="ri-record-circle-line" />
                </button>
              </div>
            </div>
          </Container>
        </div>
      </div>

      <div className="vertical-overlay" />
      <EditPestCompanyModal />
    </React.Fragment>
  );
});

export default Sidebar;
